import { useDispatch, useSteps } from 'components/Booking-new/hooks';
import { setChangeLocation, setLocation } from 'components/Booking-new/actions/actions';
import stepTypes from 'components/Booking-new/modules/Steps/types';

export default function () {
  const dispatch = useDispatch();
  const { goToNextStep, allSteps, goToStep } = useSteps();

  const selectLocation = location => {
    dispatch(setLocation(location));
    goToNextStep();
  };

  const locationStepIndex = allSteps.findIndex(step => step?.type === stepTypes.location);

  const goToLocationStep = () => goToStep(locationStepIndex);

  const changeLocationLabel = allSteps[locationStepIndex]?.data?.changeLocationLabel || 'Change location';

  const changeLocation = () => dispatch(setChangeLocation());

  return {
    selectLocation,
    changeLocation,
    goToLocationStep,
    changeLocationLabel,
  };
}
